import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** The goo is glossy blob voxels: every blob in a Groove letters world is goo. */
export const GROOVE_GOO = liquidKind('blob')

/** One input's goo and its slump; a whole stroke is one undo step (as 013 Sludge). */
export const GROOVE_SETTLE = liquidSettleEvent('experience.groove-letters.settle', GROOVE_GOO)

/** Reducer handlers for Groove letters (`experience.groove-letters.*`). */
export const eventHandlers = GROOVE_SETTLE.handlers
